import { render, staticRenderFns } from "./TeamKebabMenu.vue?vue&type=template&id=d7226c98&scoped=true&"
import script from "./TeamKebabMenu.vue?vue&type=script&lang=js&"
export * from "./TeamKebabMenu.vue?vue&type=script&lang=js&"
import style0 from "./TeamKebabMenu.vue?vue&type=style&index=0&id=d7226c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7226c98",
  null
  
)

export default component.exports